export enum RoleType {
  Admin = 'TecAlliance OM Admins'
}
